export default __webpack_public_path__ + "c74406d25b3e46d7d7ae7afa630cb3a4.svg";